export default __webpack_public_path__ + "static/img4-0976e689de501641e3b1e1046a6e17ef.jpg";